import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { links } from './layoutItems/links';
import { hasPermission } from '../store/apiWrapper';
import { isRepiWeb } from '../store/storeFunctions';

class Home extends React.Component {
    render() {
        const authorized = this.props.authentication.isAuthorized;

        if(authorized) {
            if (isRepiWeb())
                return this.redirect("/repi/search");

            if (!hasPermission(null, "MainSearch") && (!this.state || !this.state.warningShowedOnce)) {
                var redirectLink = "";
                links.sort((a, b) => a.orderSk - b.orderSk).map((p, i) => { if (p.canShow() === true && redirectLink === "") redirectLink = p.link; })
                if (redirectLink !== "") return this.redirect(redirectLink);
                if (hasPermission(null, "MainRepi")) return this.redirect("/repi/search");
                if (hasPermission(null, 'MainMonitoring')) return this.redirect("/monitoring/portfolioOverview");
            }

            return <Redirect to={{ pathname: "/search", state: { reset: true } }}/>
        }

        return <Redirect to="/login" />
    }

    redirect = (link) => {
        this.setState({ warningShowedOnce: true });
        return <Redirect to={link} />;
    }
}

export default connect(state => state.userContext, null)(Home);